export default "__VITE_ASSET__6b4fe08d__"